import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { AppContext } from 'store/AppContext';
import { getKjordaemi } from 'common/services/apiService';


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function KjordaemiFilter(props) {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { setFilters, setKjordaemisnumerFromFilter, disabled } = props;
  const [kjordaemiList, setKjordaemiList] = useState([]);
  const [kjordaemisnumer, setKjordaemisnumer] = useState('');

  useEffect(() => {
    async function fetchKjordaemi() {
      const { data, isSuccess, error } = await getKjordaemi(context, []);
      
      if (isSuccess) {
        setKjordaemiList(data);
      } else {
        console.error(error);
      }
    };

    fetchKjordaemi();
  }, [context]);

  const handleChange = event => {
    setKjordaemisnumer(event.target.value);
    setKjordaemisnumerFromFilter && setKjordaemisnumerFromFilter(event.target.value);

    setFilters(state => ({
      ...state,
      kjordaemisnumer: event.target.value
    }));
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="filters-kjordaemi-select" shrink>
          Kjördæmi
        </InputLabel>
        <Select
          labelId="filters-kjordaemi-select-label"
          id="filters-kjordaemi-select"
          value={kjordaemisnumer}
          displayEmpty={true}
          onChange={handleChange}
          disabled={disabled ? disabled : false}
        >
          <MenuItem value="">
            <em>Öll kjördæmi</em>
          </MenuItem>
          {kjordaemiList.map((k) => (
            <MenuItem key={k.numerKjordaemis} value={k.numerKjordaemis}>
              {k.kjordaemi}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}